<template>
  <div class="dashboard_warp">
    <div class="home-top">
      <div class="top-panle" v-for="(item,index) in topList" :key="index">
        <img :src="item.img" alt="">
        <div class="top-panle-right">
          <span class="text-18 size-191">{{item.text}}</span>
          <span class="text-40 size-000 text-bold">{{item.value}}</span>
          <span class="text-16 size-4a4">较昨日<span :style="{'margin-left':'5px',color:item.jia ? '#00BA3C' : '#FF2440'}"
          >{{item.jia ? '+' : ''}}{{item.rato}}</span></span>
        </div>
      </div>
    </div>
    <div class="home-mid">
      <div class="home-mid-top">
        <div class="mid-top-left">
          <div class="min-left-list" v-for="(item,index) in midList" :key="index" @click="onMid(index)">
            <span class="text-18" :style="{color:index == curMid ? '#000' : '#666'}">{{item}}</span>
            <div class="mid-line" v-if="index == curMid"></div>
          </div>
        </div>
        <div class="mid-top-right">
          <span class="text-14" :style="{color:0 == rightMid ? '#7732FC' : '#666','margin-right':'24px','cursor':'pointer'}" @click="onRightMid(0)">本周</span>
          <span class="text-14" :style="{color:1 == rightMid ? '#7732FC' : '#666','margin-right':'24px','cursor':'pointer'}" @click="onRightMid(1)">本月</span>
          <span class="text-14" :style="{color:2 == rightMid ? '#7732FC' : '#666','margin-right':'24px','cursor':'pointer'}" @click="onRightMid(2)">本年</span>
          <el-date-picker
            v-model="curTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            >
          </el-date-picker>
        </div>
      </div>
      <div class="home-mid-bottom" id="chart">

      </div>
    </div>
    <div class="mid-bottom-list-panel">
      <div class="list-box" @click="onDetail(index)" v-for="(item,index) in bottomList" :key="index" :style="{background:item.color}">
        <span class="text-4a4 text-16">{{item.text}}</span>
        <span class="text-191 text-20 text-bold">{{item.value}}</span>
        <i class="el-icon-arrow-right list-box-jiao" style="font-size:14px;color:#4a4a4a" />
      </div>
    </div>
    <div class="bottom-panel">
      <div class="bottom-left-panel">
        <span class="text-000 text-18" style="dispaly:block">商品销量排行</span>
         <el-table
          :data="leftTableList"
          style="width: 100%"
          :cell-style="{border:'0px' ,'padding':'5px 0',height:'20px'}"
          :header-cell-style="{border:'0px','height':'20px','min-height':'20px','padding':'5px 0'}"
          >
          <el-table-column
            label="排名"
            width="48"
            align="center"
            >
            <template slot-scope="scope">
              <img v-if="scope.row.rankNum == 1" src="../../assets/dashboard/rank_0.png" class="rank-img" />
              <img v-if="scope.row.rankNum == 2" src="../../assets/dashboard/rank_1.png" class="rank-img" />
              <img v-if="scope.row.rankNum == 3" src="../../assets/dashboard/rank_2.png" class="rank-img" />
              <span v-if="scope.row.rankNum > 3">{{scope.row.rankNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="商品图"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
              <img :src="scope.row.mainGraph" class="group-img" />
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            align="left"
            show-overflow-tooltip
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            align="center"
            show-overflow-tooltip
            label="单价">
          </el-table-column>
          <el-table-column
            prop="buyNum"
            align="center"
            show-overflow-tooltip
            label="销量">
          </el-table-column>
          <el-table-column
            prop="salesAmount"
            align="center"
            show-overflow-tooltip
            label="总销量(元)">
          </el-table-column>
         
        </el-table>
      </div>

      <div class="bottom-left-panel">
        <span class="text-000 text-18" style="dispaly:block">贡献值排行</span>
         <el-table
          :data="rightTableList"
          style="width: 100%"
          :cell-style="{border:'0px' ,'padding':'5px 0',height:'20px'}"
          :header-cell-style="{border:'0px','height':'20px','min-height':'20px','padding':'5px 0'}"
          >
          <el-table-column
            label="排名"
            width="48"
            align="center"
            >
            <template slot-scope="scope">
              <img v-if="scope.row.rankNum == 1" src="../../assets/dashboard/rank_0.png" class="rank-img" />
              <img v-if="scope.row.rankNum == 2" src="../../assets/dashboard/rank_1.png" class="rank-img" />
              <img v-if="scope.row.rankNum == 3" src="../../assets/dashboard/rank_2.png" class="rank-img" />
              <span v-if="scope.row.rankNum > 3">{{scope.row.rankNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名称"
            align="center"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="time"
            align="left"
            show-overflow-tooltip
            label="注册时间">
          </el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            show-overflow-tooltip
            label="总贡献值">
          </el-table-column>
          <el-table-column
            prop="monthAmount"
            align="center"
            show-overflow-tooltip
            label="近一月贡献值">
          </el-table-column>
         
        </el-table>
      </div>
    </div>
    <Delail :show="delailShow" :index="curDelailIndex" @close="onClose" :title="title"></Delail>
  </div>
</template>

<script>
import echarts from "echarts";
import Delail from "./components/delail.vue"
import {
  getSalesStatistics,
  getDataSummary,
  getExpendTop10,
} from "@/api/dashboard";

import {
  getProductSales,
} from "@/api/operation";
import {formatDateOne} from '@/utils/utils'

export default {
  name: "Dashboard",
  data() {
    return {
      topList:[
        {text:'总销量(元)',value:'0',rato:'0%',jia:true,img:require('../../assets/dashboard/home_0.png')},
        {text:'总订单量（单)',value:'0',rato:'0%',jia:true,img:require('../../assets/dashboard/home_1.png')},
        {text:'总会员数',value:'0',rato:'0%',jia:true,img:require('../../assets/dashboard/home_2.png')},
        {text:'总销量(元)',value:'0',rato:'0%',jia:true,img:require('../../assets/dashboard/home_3.png')},
      ],
      midList:['销量分析','订单量分析','会员数分析','提现分析'],
      curMid:0,
      rightMid:0,
      curTime:null,
      bottomList:[
        {text:'总贡献值',value:'0',color:'rgba(61, 158, 251, 0.12)'},
        {text:'总现金金额',value:'0',color:'rgba(0, 202, 150, 0.1)'},
        {text:'抽奖次数总量',value:'0',color:'rgba(245, 80, 119, 0.1)'},
        {text:'兑换券总量',value:'0',color:'rgba(246, 185, 79, 0.1)'},
        {text:'数字积分总量',value:'0',color:'rgba(61, 158, 251, 0.12)'},
        {text:'新增订单',value:'0',color:'rgba(0, 202, 150, 0.1)'},
        {text:'售后待处理',value:'0',color:'rgba(245, 80, 119, 0.1)'},
        {text:'新增客户',value:'0',color:'rgba(246, 185, 79, 0.1)'},
      ],
      leftTableList:[],
      rightTableList:[],
      curData:null,
      chart:null,
      delailShow:false,
      curDelailIndex:-1,
      title:'',
    };
  },
  components:{Delail},
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null;
    }
    
  },
  mounted(){
    let _this = this;
    window.addEventListener('resize',function(){
      if(_this.chart){
        _this.chart.resize();
      }
    })
    // this.getWeek(0);
    // this.getSummary();
    // this.getTop10();
    // this.getProduct();
    
  },
  methods: {
    getTop10(){
      getExpendTop10().then(res=>{
        this.rightTableList = res.data;
        this.rightTableList.forEach(item=>{
          item.time = formatDateOne(new Date(item.date), 4);
        })
      })
    },
    getProduct(){
      getProductSales().then(res=>{
        this.leftTableList = res.data;
        this.leftTableList.forEach((item,index)=>{
          item.rankNum = index + 1;
        })
      })
    },
    onClose(){
      this.curDelailIndex = -1;
      this.delailShow = false;
      this.title = '';

    },
    onDetail(index){
      this.curDelailIndex = index;
      this.title = this.bottomList[index].text;
      console.log('title',this.title)
      this.delailShow = true;
    },
    getSummary(){
      getDataSummary().then(res=>{
        let {totalExpend,totalBalance,totalRedpacket,totalRaffleTimes,
          totalVcoin,totalOrder,afterPendingOrder,newAddUser
        } = res.data;
        this.bottomList = [
          {text:'总贡献值',value:(totalExpend / 1000).toFixed(2) + 'K',color:'rgba(61, 158, 251, 0.12)'},
          {text:'总现金金额',value:(totalBalance / 1000).toFixed(2) + 'K',color:'rgba(0, 202, 150, 0.1)'},
          {text:'抽奖次数总量',value:totalRaffleTimes,color:'rgba(245, 80, 119, 0.1)'},
          {text:'兑换券总量',value:totalRedpacket,color:'rgba(246, 185, 79, 0.1)'},
          {text:'数字积分总量',value:(totalVcoin / 1000).toFixed(2) + 'K',color:'rgba(61, 158, 251, 0.12)'},
          {text:'新增订单',value:totalOrder,color:'rgba(0, 202, 150, 0.1)'},
          {text:'售后待处理',value:afterPendingOrder,color:'rgba(245, 80, 119, 0.1)'},
          {text:'新增客户',value:newAddUser,color:'rgba(246, 185, 79, 0.1)'},
        ]
      })
    },
    getWeek(value){
        this.curTime = []
        console.log('startTime',this.curTime);

        let now = new Date();
        console.log('startTime',now)
        let start = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
        console.log('startTime1',start)
        if(value == 0){
          start = new Date(now.getTime() - 3600 * 1000 * 24 * 7);
        }else if(value == 1){
          start = new Date(now.getTime() - 3600 * 1000 * 24 * 30);
        }else if(value == 2){
          start = new Date(now.getTime() - 3600 * 1000 * 24 * 365);
        }
        this.curTime.push(start);
        this.curTime.push(now);
        this.getSales();
    },
    getSales(){
      let params = {};
    
      if(this.curTime && this.curTime.length){
        let start = this.curTime[0];
        let end = this.curTime[1];

         let startTime = start.setHours(0,0,0,0);
        let endTime = end.setHours(23,59,59);

        params['startTime'] = startTime;
        params['endTime'] = endTime;
        console.log('startTime',params)
        
      }
      getSalesStatistics(params).then(res=>{
        this.curData = res.data;
        this.topList = [
          {text:'总销售额(元)',value:(this.curData.salesStatistics.totalAmount / 1000).toFixed(2) + 'K',rato:this.curData.salesStatistics.ratio + '%',jia:this.curData.salesStatistics.ratio >= 0,img:require('../../assets/dashboard/home_0.png')},
          {text:'总订单量（单)',value:this.curData.orderNumStatistics.totalOrderNum,rato:this.curData.orderNumStatistics.ratio + '%',jia:this.curData.orderNumStatistics.ratio >= 0,img:require('../../assets/dashboard/home_1.png')},
          {text:'总会员数',value:this.curData.userStatistics.totalUsers,rato:this.curData.userStatistics.ratio + '%',jia:this.curData.userStatistics.ratio >= 0,img:require('../../assets/dashboard/home_2.png')},
          {text:'总提现(元)',value:(this.curData.withdrawStatistics.totalAmount / 1000).toFixed(2) + 'K',rato:this.curData.withdrawStatistics.ratio + '%',jia:this.curData.withdrawStatistics.ratio >= 0,img:require('../../assets/dashboard/home_3.png')},
        ]
        this.initChart();
      })
    },
    initChart(){
      if(!this.chart){
        let chartDom = document.getElementById('chart');
        this.chart = echarts.init(chartDom);
      }
      let data = [];

      if(this.curMid == 0){
        data = this.curData.salesStatistics.dataAnalysis;
      }else if(this.curMid == 1){
        data = this.curData.orderNumStatistics.dataAnalysis;
      }else if(this.curMid == 2){
        data = this.curData.userStatistics.dataAnalysis;
      }else if(this.curMid == 3){
        data = this.curData.withdrawStatistics.dataAnalysis;
      }

      let time = [];
      let valueData = [];

      if(data && data.length){
        data.forEach(item=>{
          time.push(item.date);
          valueData.push(item.number)
        })
      }
      

      let option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: time,
          splitLine:{
            show:false
          }
          
        },
        yAxis: {
          type: 'value',
          splitLine:{
            show:false
          }
        },
        tooltip:{},
        series: [
          {
            data: valueData,
            type: 'line',
            smooth:true,
            lineStyle:{
              color:'#7732FC',
              width:2
            },
            symbol:'circle',
            symbolSize:8,
            itemStyle:{
              normal:{
                color:'#7732FC'
              }
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(119, 50, 252, 0.85)' // 起始颜色
                }, {
                    offset: 1,
                    color: 'rgba(119, 50, 252, 0)' // 结束颜色
                }])
            }
          }
        ]
      };

      option && this.chart.setOption(option);
    },
    onMid(index){
      if(index != this.curMid){
        this.curMid = index;
        this.getSales();
      }
    },
    dateChange(dataArr){
      console.log('data',dataArr)
      this.curTime = [];
      this.curTime = dataArr;
      this.getSales();
    },
    onRightMid(index){
      console.log('index',index)
      if(index != this.rightMid){
        this.rightMid = index;
        this.getWeek(index);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-14{
  font-size:14px;
}
.text-16{
  font-size:16px;
}
.text-18{
  font-size:18px;
}
.text-20{
  font-size:20px;
}
.text-40{
  font-size:40px;
}
.text-bold{
  font-weight: bold;
}
.size-000{
  color:#000;
}
.size-191{
  color:#191919;
}
.size-4a4{
  color:#4a4a4a;
}
.center{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard_warp {
  // background: #f7f7f7;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 106px);
  padding: 30px;
  box-sizing: border-box;
  overflow-y: auto;
  .home-mid{
    width:100%;
    height:331px;
    margin-top:24px;
    min-height:331px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    .home-mid-bottom{
      width:100%;
      height:calc(100% - 65px);
      display: flex;
    }
    .home-mid-top{
      width:100%;
      height:65px;
      min-height:65px;
      display: flex;
      flex-direction: row;
      padding:0 24px;
      box-sizing: border-box;
      justify-content: space-between;
      position: relative;
      align-items: center;
      border-bottom:1px solid #e8e8e8;
      .mid-top-right{
        height:100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
      }
      .mid-top-left{
        height:100%;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        .min-left-list{
          height:100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-right:32px;
          cursor: pointer;
          .mid-line{
            width:100%;
            height:2px;
            background: #333;
            position: absolute;
            bottom:0;
          }
        }
      }
    }
  }
  .bottom-panel{
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:24px;
    .bottom-left-panel{
      width:48.5%;
      display: flex;
      flex-direction: column;
      padding: 24px 20px;
      box-sizing: border-box;
      border-radius: 8px;
      background: #fff;
    }
    
  }
  .mid-bottom-list-panel{
    width:100%;
    margin-top:24px;
    height:92px;
    min-height:92px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .list-box{
      width:11.5%;
      height:100%;
      display: flex;
      padding: 20px 16px;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      border-radius: 4px;
      cursor: pointer;
      .list-box-jiao{
        position: absolute;
        right:16px;
      }
    }
  }
  .home-top{
    width:100%;
    height:146px;
    min-height:146px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .top-panle{
      width:23%;
      height:100%;
      display: flex;
      flex-direction: row;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 8px;
      background: #fff;
      .top-panle-right{
        margin-left:24px;
        flex:1;
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      img{
        width:40px;
        height:40px;
      }
    }
  }
}
.el-table::before{
  height:0;
}
.rank-img{
  width:20px;
  height:24px;
}
.group-img{
  width:32px;
  height:32px;
  border-radius: 4px;
}
</style>

